import React from 'react';
import './art.css'; 
import bgart from '../images/bgart.webp';

function Art() {
  const artData = Array.from({ length: 50 }, (_, i) => ({
    id: i + 1,
    img: "art"
  }));

  return (
    <>
      <section className='art' style={{ backgroundImage: `url(${bgart})` }} name='art'>
        <ol>
          {artData.map((art) => {
            const img = `${process.env.PUBLIC_URL}/images/art/${art.id}.jpg`;
            return (
              <li key={art.id}>
                <figure>
                  <img width="100%" src={img} alt={`Art ${art.id}`} />
                </figure>
              </li>
            );
          })}
        </ol>
      </section>
    </>
  );
}

export default Art;